export enum HeaderActions {
  UpdateHeight = 'UPDATE_HEIGHT',
}

export interface HeaderType {
  height: number | string;
}

export type HeaderPayloadType = {
  [HeaderActions.UpdateHeight]: number | string;
};
